import React from 'react';

import styles from './Image.module.css';

/**
 * Composant pour afficher des images WebP avec fallback PNG
 * pour les navigateurs qui ne supportent pas le format WebP
 */
const Image: React.FC<ImageProps> = ({ webpSrc, defaultSrc, alt, className, width, height, style, effect }) => {
  const imageClassName = `${className ?? ''} ${effect ? styles[effect] : ''}`;

  return (
    <picture>
      {webpSrc && (
        <source
          srcSet={webpSrc}
          type="image/webp"
          className={imageClassName}
          width={width}
          height={height}
          style={style}
        />
      )}
      <img
        src={defaultSrc}
        alt={alt}
        className={imageClassName}
        loading="lazy"
        width={width}
        height={height}
        style={style}
      />
    </picture>
  );
};

export interface ImageProps {
  webpSrc?: string;
  defaultSrc: string;
  alt: string;
  className?: string;
  width?: string | number;
  height?: string | number;
  style?: React.CSSProperties;
  effect?: 'blur' | 'blackWhite';
}

export default Image;
